var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"signature-canvas",class:{
    'is-disabled': _vm.disabled,
    'is-virtual-landscape': _vm.virtualLandscape
  }},[_c('canvas',{ref:"canvas",staticClass:"signature-canvas__surface"}),(_vm.isCanvasEmpty)?_c('div',{staticClass:"signature-canvas__placeholder"},[_vm._v("请在签名区域签字")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }